module.exports = __webpack_public_path__ + "fonts/adcde98f1d584de52060ad7b16373da3.woff";